import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import SettingsComponent from "./SettingsComponent";
import DeleteConfirm from "Common/Confirm/DeleteConfirm";
import _ from "i18n";

import {
  setBlocsOrder,
  addNewDrawer,
  setScope,
  setGroup,
  setWidgets,
  setApps,
  deleteSetting,
  setLayoutName
} from "Actions";

class Settings extends Component {
  constructor(props) {
    super(props);

    this.onConfirmDelete = this.onConfirmDelete.bind(this);
    this.state = {
      isModalOpen: false,
      deleteIndex: -1
    };
  }
  componentDidMount() {
    const { saveBloc } = this.props;
    const unblock = this.props.history.block((location, action) => {
      if (this.props.unsaved) {
        const save = window.confirm("Do you want to save change ?");
        if (save) {
          saveBloc();
          return false;
        } else {
          window.location.reload();
        }
      }
      return true;
    });

    return () => {
      unblock();
    };
  }

  closeModalDelete() {
    this.setState({ isModalOpen: false, deleteIndex: -1 });
  }

  openModalDelete(index) {
    console.log(index);
    this.setState({
      isModalOpen: true,
      deleteIndex: index
    });
  }

  onConfirmDelete() {
    const { deleteIndex } = this.state;
    this.setState({ isModalOpen: false });
    this.props.deleteSetting(deleteIndex);
  }

  render() {
    const {
      blocs,
      auth,
      saving,
      setBlocsOrder,
      addNewDrawer,
      setScope,
      setGroup,
      setWidgets,
      setApps,
      setLayoutName,
      deleteSetting,
      saveBloc,
      setUnsaved
    } = this.props;
    return (
      <div>
        <div className="grid-x grid-margin-y">
          {blocs.map((bloc, index) => (
            <div
              key={`bloc${index}`}
              className="cell small-12 medium-12 large-6"
            >
              <SettingsComponent
                saving={saving}
                setBlocsOrder={setBlocsOrder}
                addNewDrawer={addNewDrawer}
                auth={auth}
                config={bloc.config}
                scope={bloc.scope}
                group={bloc.group}
                widgets={bloc.widgets}
                apps={bloc.apps}
                name={bloc.name || ""}
                indexSetting={index}
                setScope={setScope}
                setGroup={setGroup}
                setLayoutName={setLayoutName}
                setWidgets={setWidgets}
                setApps={setApps}
                deleteSetting={deleteSetting}
                saveBloc={saveBloc}
                setUnsaved={setUnsaved}
                openModalDelete={this.openModalDelete.bind(this)}
              />
            </div>
          ))}
        </div>
        <DeleteConfirm
          isOpen={this.state.isModalOpen}
          onCancel={() => this.closeModalDelete()}
          onConfirm={() => this.onConfirmDelete()}
          text={_("Are you sure you want to delete the layout ?")}
        />
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  blocs: state.hub.blocs,
  saving: state.hub.saving,
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  setBlocsOrder: (oldIndex, newIndex, indexSetting) =>
    dispatch(setBlocsOrder(oldIndex, newIndex, indexSetting)),
  addNewDrawer: indexSetting => dispatch(addNewDrawer(indexSetting)),
  setScope: (scope, indexSetting) => dispatch(setScope(scope, indexSetting)),
  setGroup: (group, indexSetting) => dispatch(setGroup(group, indexSetting)),
  setWidgets: (widgets, indexSetting) =>
    dispatch(setWidgets(widgets, indexSetting)),
  setApps: (apps, indexSetting) => dispatch(setApps(apps, indexSetting)),
  setLayoutName: (name, indexSetting) =>
    dispatch(setLayoutName(name, indexSetting)),
  deleteSetting: indexSetting => dispatch(deleteSetting(indexSetting))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Settings)
);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Settings/index.js